import React from 'react'
import { BlueBoxDiv, ChallengeDescriptionDiv, ChallengeNameDiv, ChallengeProgressBar, ChallengeProgressBarFilled, ChallengeProgressbarDiv, ChallengeRewardAmount, ChallengeRewardDiv, ChallengeRootDiv, ChallengeTypeAndDate, ChallgeDetailsDiv, ProgressDiv, ProgressTextDiv } from './ChallengeCard.style'
import { RUPEE_SYMBOL } from '../Strings'
// import rewardIcon from '../assets/challenge/challengeGift.svg'
import rewardIcon from '../assets/challenge/newRewardIcon.png'
import { ExpiredStamp } from './MissionCard.styles'
import { convertToWords } from '../Common/Utils'

function ChallengeCard(props) {
    const { challengeData } = props

    console.log(`Challenge Data In the card >>> `, challengeData)
    let gamesWon = Number(challengeData.gameWon)
    gamesWon = isNaN(gamesWon)? 0 : gamesWon;


    let gamesCount = Number(challengeData.gameCount)
    gamesCount = isNaN(gamesCount) ? 1 : gamesCount;

    let progressFillingPercentage = challengeData.special  ? (challengeData.specialChallengeCounter / challengeData.specialChallengeDurationCap) * 100 : (gamesWon / gamesCount) * 100;
    progressFillingPercentage += '%'

    console.log(`Progress Bar Filling Percentage is >>> `, progressFillingPercentage)

    let entryText = challengeData.challengeName.toLowerCase().search('point') >= 0 ?
         "Pt. Value:" +challengeData.entry : "Entry:" + RUPEE_SYMBOL+challengeData.entry

    return (

       <div style={{width: '96%', position:'relative'}}>
        <ChallengeRootDiv specialChallengeCard={challengeData?.special ? true : false} id='ChallegeRoot'>
            <ChallgeDetailsDiv>

                <ChallengeNameDiv specialChallengeCard={challengeData?.special ? true : false}> {challengeData.challengeName  }
                    <span style={{ fontSize: '0.688rem', fontWeight: '500', color: challengeData?.special? "#F9F9F9":'#032146' }}> ({challengeData.player} | {entryText}) </span>
                </ChallengeNameDiv>

                <ChallengeTypeAndDate>
                    <BlueBoxDiv fWeight={challengeData?.special ? "bold" : "500"} color={challengeData?.special ? "#02181E" : "#032146"} bgColor = {challengeData?.special ? "#EABF69" : "#1E396433"}> {challengeData.challengeType}</BlueBoxDiv>
                    <BlueBoxDiv fWeight={ "500"} color={challengeData?.special ? "#FFFFFF" : "#032146"} bgColor= {challengeData?.special ? "rgba(255, 184, 52, 0.3)" : " #1E396433"}> {challengeData.duration}</BlueBoxDiv>
                </ChallengeTypeAndDate>

                <ChallengeDescriptionDiv color={challengeData?.special ? "rgba(249, 249, 249, 1)" : "#223655"}> {challengeData.challengeDescription} </ChallengeDescriptionDiv>
                    {challengeData?.special && <div style={{
                        "background": "rgba(0, 0, 0, 0.38)",
                        "padding": "0px 6px 0px 6px",
                        "gap": "10px",
                        "borderRadius": "4px",
                        "fontSize":"0.625rem",
                        "fontWeight":"500",
                        "width":"fit-content",
                        "display":"inline-block",
                        "color": "rgba(234, 191, 105, 1)",
                        "lineHeight":"13.55px"
                    }}>{challengeData.progressBarText} today</div>
                    }

                <ChallengeProgressbarDiv id='pgDiv'>
                    <ChallengeProgressBar specialChallengeCard={challengeData?.special ? true : false}  shouldShade={false} isFromBundle={false}>
                        <ChallengeProgressBarFilled shouldShade={false} fillArea={progressFillingPercentage} />
                    </ChallengeProgressBar>
                    <ProgressTextDiv specialChallengeCard={challengeData?.special ? true : false}  >
                    {challengeData?.special ? `${challengeData?.specialChallengeCounter}/${challengeData?.specialChallengeDurationCap} days completed` : challengeData.progressBarText}
                    </ProgressTextDiv>
                </ChallengeProgressbarDiv>
            </ChallgeDetailsDiv>


            <ChallengeRewardDiv specialChallengeCard={challengeData?.special ? true : false}  id='Reward Div'>
            {challengeData?.special && <div  style={{
                    "background": "linear-gradient(180deg, #1c150d5e, #d8bb89 48.5%, #1b140c4d)",
                    "height": "100%",    
                    "left": 0,
                    "position": "absolute",
                    "width": "1px"
                }}></div>
                }
                <img src={rewardIcon} style={{width:'1.6rem', height:'1.75rem', marginTop:'1rem'}} alt='reward-Icon' />
                <div style={{fontWeight:'500', fontSize:'0.875rem', color:'#F2F2F2'}}>Get</div>
                <ChallengeRewardAmount  specialChallengeCard={challengeData?.special ? true : false} >{RUPEE_SYMBOL}{challengeData?.special ? convertToWords(challengeData.winningAmount) : challengeData.winningAmount} </ChallengeRewardAmount>
            </ChallengeRewardDiv>

            

        </ChallengeRootDiv>

        <ExpiredStamp style={{position:'absolute', top:'35%', left:'30%'}}>
      <span style={{ fontSize:'0.75rem', fontWeight:'700', rotate:'15 deg'}}> EXPIRES ON REDEEM </span>
    </ExpiredStamp>
        </div>
    )
}


export default ChallengeCard